import { render } from "./RoomMapSettings.vue?vue&type=template&id=bbe126b6"
import script from "./RoomMapSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./RoomMapSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./RoomMapSettings.vue?vue&type=style&index=0&id=bbe126b6&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__